module.exports = __webpack_public_path__ + "static/media/model1.7b879830.jpg";